module.exports = __webpack_public_path__ + "static/media/principals.60301c17.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/ide/principals.jpg
 ** module id = 147
 ** module chunks = 0
 **/